import React from 'react';
import {SpinnerOverlay} from './SpinnerOverlay'

export default function Loading () {
  return <SpinnerOverlay loadingText='Loading ...' backgroundColor='white' color='darkgray'/>
}